import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const DiagonalWidgetBackground = ({ imageUrl, imageAltText, children, className, hideImg }) => {
    const hasImage = !hideImg && imageUrl;
    const bgStyle = {
        background: hasImage ? `url("${imageUrl}")` : null,
        backgroundSize: hasImage ? "cover" : "auto"
    };
    return (_jsx("div", { style: bgStyle, role: "img", "aria-label": imageAltText, className: cn("diagonal-widget-background", !imageUrl && "diagonal-widget-background--no-img", className), children: children }));
};
export default DiagonalWidgetBackground;
